import React, { useState } from 'react';
import Swal from 'sweetalert2';

export default function Deleteprofilerequest() {
  const [email, setEmail] = useState('');

  const handleDelete = async (e) => {
    e.preventDefault();

    if (!email) {
      Swal.fire('Error', 'Please enter your email address.', 'error');
      return;
    }

    // Confirmation dialog
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `This will permanently delete the profile for: ${email}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      // TODO: Replace with actual API call
      console.log(`Deleting profile for ${email}`);

      // Show success alert
      Swal.fire('Deleted!', 'Your profile has been deleted.', 'success');
      setEmail('');
    }
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '400px', margin: 'auto' }}>
      <h2>Delete Profile</h2>
      <form onSubmit={handleDelete}>
        <label htmlFor="email">Enter your email:</label>
        <input
          type="email"
          id="email"
          placeholder="you@example.com"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          style={{
            width: '100%',
            padding: '0.5rem',
            marginTop: '0.5rem',
            marginBottom: '1rem',
          }}
        />
        <button
          type="submit"
          style={{
            backgroundColor: '#e53935',
            color: 'white',
            padding: '0.5rem 1rem',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          Delete Profile
        </button>
      </form>
    </div>
  );
}
